import React, { useEffect, useState } from 'react'
import { AddPlaylistButton, PlaylistButton, PlayPauseButton, RepeatButton, SaveMixButton, ShareMixButton, ShuffleButton, TimerButton } from '../../Util/icons';
import MixerTray from './Mixer/MixerTray';
import { useDispatch, useSelector } from 'react-redux';
import { handleMixTrayGlobal, handleSaveMixModalGlobal, handleSaveSuccessMixModal, handleShareMixModalGlobal, setIsMixSaved, setModalIsOpenForSaveAndShare } from '../../Store/Slices/SaveMixSlice';
import { setConfig, setSelectedItem, setSelectedType, togglePlayPause } from '../../Store/Slices/PlayerSlice';

import TimerModal from './Timer/TimerModal';
import Player from './Player';
import { GetPlayingTracks } from '../../Hooks/CurrentTracks';
import { useNavigate } from 'react-router';
import { formatTime, isProtectedRouteForBottomPlayerBar } from '../../Util/helpers';
import { setShowPaywallModal } from '../../Store/Slices/UserSlice';
import GlobalModals from '../GlobalModals';
import { handlePlaylistTray, handleSaveMixModal } from '../../Store/Slices/ModalSlice';

import './style.css'
import AddToPlaylistTray from './Playlist/AddToPlaylistTray';

const BottomPlayerBar = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const playingTracks = GetPlayingTracks();
    const isActive = playingTracks.length > 0;

    const tracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isPlaying = useSelector((state) => state.player.isPlaying);
    const isMixerTrayOpen = useSelector((state) => state.mixStatus.isMixerTrayOpen);
    const isOpenPlaylistTray = useSelector((state) => state.modal.isOpenPlaylistTray);
    const checkElegibility = useSelector((state) => state.user.checkElegibility);
    const { timeLeft, isRunning } = useSelector((state) => state.timer);

    const [openTimerModal, setOpenTimerModal] = useState(false);

    useEffect(() => {
        if (!isActive) {
            dispatch(handleMixTrayGlobal(false));
        }
    }, [isActive])

    const handleMixerTray = () => {
        if (isActive) {
            dispatch(handlePlaylistTray(false));
            dispatch(handleMixTrayGlobal(!isMixerTrayOpen));
        }
    };

    const handlePlaylistTrayInline = () => {
        if (isActive) {
            dispatch(handleMixTrayGlobal(false));
            dispatch(handlePlaylistTray(!isOpenPlaylistTray));
        }
    }

    const openSaveMixModal = () => {
        if (isActive) {
            if (!checkElegibility) {
                dispatch(setShowPaywallModal(true));
                return
            }
            dispatch(setSelectedType('default'));
            dispatch(setSelectedItem(tracks));
            dispatch(handleSaveMixModal(true));
        }
    }

    const handleShowTimer = () => {
        if (isActive) {
            setOpenTimerModal(true);
        }
    }

    // Handlers
    const handleTogglePlayPause = () => {
        dispatch(togglePlayPause());
    }

    const handleShuffleMode = () => {
        dispatch(setConfig({ isShuffle: !config.isShuffle }));
        console.log("Shuffle mode toggled");
    }

    const handleRepeatMode = () => {
        dispatch(setConfig({ isRepeat: !config.isRepeat }));
        console.log("Repeat mode toggled");
    }


    const navigateToMyMixes = () => {
        navigate('/my-mixes');
    }

    if (isProtectedRouteForBottomPlayerBar()) {
        return null;
    }

    return (
        <>
            {/* Global invisible player */}
            <Player />

            <div className={`audioPlayerWrapper ${(window.innerWidth < 575 && !isActive) && 'd-none'}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex">
                            <div className="audioPlayerControls playing-audio-player-controls">
                                <PlayPauseButton isActive={isActive} isPlaying={isPlaying} handleClick={handleTogglePlayPause} />
                                {isMixerTrayOpen && config?.type === 'playlist' ? <ShuffleButton isActive={config.isShuffle} handleClick={handleShuffleMode} /> : <SaveMixButton handleClick={openSaveMixModal} />}
                                {/* <AddPlaylistButton handleClick={handlePlaylistTrayInline} /> */}
                                <PlaylistButton handleClick={navigateToMyMixes} />
                                {isMixerTrayOpen && config?.type === 'playlist' ? <RepeatButton isActive={config.isRepeat} handleClick={handleRepeatMode} /> : <TimerButton timer={isRunning ? formatTime(timeLeft) : "Timer"} handleClick={handleShowTimer} />}
                                <ShareMixButton isActive={isActive} handleClick={handleMixerTray} />
                                {window.innerWidth > 575 && (
                                    <>
                                        <MixerTray isOpen={isMixerTrayOpen} onClose={handleMixerTray} />
                                        <AddToPlaylistTray isOpen={isOpenPlaylistTray} onClose={handlePlaylistTrayInline} />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {window.innerWidth < 575 && (
                <>
                    <MixerTray isOpen={isMixerTrayOpen} onClose={handleMixerTray} />
                    <AddToPlaylistTray isOpen={isOpenPlaylistTray} onClose={handlePlaylistTrayInline} />
                </>
            )}


            <TimerModal isOpen={openTimerModal} onClose={() => setOpenTimerModal(false)} />
            <GlobalModals />

        </>
    )
}

export default BottomPlayerBar
